import { useNavigate } from "react-router-dom";
import { Alert, Button, Modal } from "react-bootstrap";
import { useTenantContext } from "../../../context/Tenant/TenantContext";

export interface DeferredRequestFailedViewProps {
  deferredRequestId: string;
  reset: () => void;
}

const DeferredRequestFailedView = ({
  deferredRequestId,
  reset,
}: DeferredRequestFailedViewProps) => {
  const navigate = useNavigate();
  const { config } = useTenantContext();
  const supportEmail: string = config.supportEmail ?? "support@basemap.co.uk";
  const supportLabel: string = config.supportLabel ?? "Basemap";
  return (
    <>
      <Modal.Body>
        <Alert variant="danger">Your request failed</Alert>
        <div>
          Please contact{" "}
          <a href={`mailto:${supportEmail}`}>{supportLabel}</a> quoting the
          following id: <code>{deferredRequestId}</code>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => reset()}>
          Retry
        </Button>
        <Button variant="danger" onClick={() => navigate("/")}>
          Cancel
        </Button>
      </Modal.Footer>
    </>
  );
};

export default DeferredRequestFailedView;
